import { atom, RecoilState } from "recoil";

export const PageAtom: RecoilState<{pageTitle: string}> = atom<{pageTitle: string}>({
    key: 'PageAtom',
    default: {
        pageTitle: "BEE123"
    } as {pageTitle: string}
});
